// extracted by mini-css-extract-plugin
export var languageItem = "LanguageItem-module--languageItem--3Jslk";
export var languageItemAnimate = "LanguageItem-module--languageItemAnimate--2YwWd";
export var languageName = "LanguageItem-module--languageName--3KLG2";
export var languageFlag = "LanguageItem-module--languageFlag--1UzND";